export enum ProductTour {
  NEW_USER = 'NEW_USER',
}

/**
 * Function to return the product tour url based on the tour & the environment
 */
export const productTour =
  (env: 'development' | 'production') => (tour: ProductTour) => {
    switch (true) {
      case tour === ProductTour.NEW_USER && env === 'development':
        return '/';
      case tour === ProductTour.NEW_USER && env === 'production':
        return '/';
      default:
        return '/';
    }
  };
